import axios from "axios";
import { baseURL } from "./ApiURL"


/*
==================================================================================
PEDIDOS
==================================================================================
*/

// src/api/requestPedidos.js  (actualiza / crea esta versión)


export async function Pedidos(Vendedor = 'none', Gerente = null, page = 1) {
  try {
    // Si pides por gerente/supervisor -> endpoint getPedidosxGerente
    if (Vendedor === 'none') {
      const url = `${baseURL}/getPedidosxGerente?CodSupervisor=${encodeURIComponent(Gerente)}&page=${page}`;
      const res = await axios.get(url);
      return res.data;
    } else {
      // Si pides por vendedor -> endpoint getPedidos
      const url = `${baseURL}/getPedidos?Vendedor[eq]=${encodeURIComponent(Vendedor)}&page=${page}`;
      const res = await axios.get(url);
      return res.data;
    }
  } catch (error) {
    console.error('Pedidos error:', error);
    return null;
  }
}



export async function Pedidos2(Vendedor = 'ALL', Gerente = null, page = 1, options = {}) {
  try {
    const params = {
      CodSupervisor: Vendedor,
      page,
      ...options // whatToSearch, Busqueda, fechaInicio, fechaFin, per_page...
    };
    const res = await axios.get(`${baseURL}/getPedidosxCobranzasGerencia`, { params });
    return res.data;
  } catch (error) {
    console.error('Pedidos2 error', error);
    return null;
  }
}


export async function SearchPedidos(CodUsuario, Filtro, Busqueda, fechaInicio, fechaFin) {
  try {
    let res;
    if (Filtro === 'Fecha') {
      res = await axios.get(baseURL + `/getPedidosPorBusqueda?CodUsuario=${CodUsuario}&fechaInicio=${fechaInicio}&fechaFin=${fechaFin}&whatToSearch=${Filtro}`);
    } else {
      res = await axios.get(baseURL + `/getPedidosPorBusqueda?CodUsuario=${CodUsuario}&Busqueda=${Busqueda}&whatToSearch=${Filtro}`)
    }
    return res.data;
  } catch (error) {
    console.log(error)
  }
}

export async function getMontoProductosPedido(Documento) {
  try {
    const res = await axios.get(baseURL + `/getMontoProductosPedido?Documento=${Documento}`);
    return res.data;
  } catch (error) {
    console.log(error)
  }
}

export async function getProductos(Documento) {
  try {
    const res = await axios.get(baseURL + `/getProductosPedidos?Documento[eq]=${Documento}`);
    return res.data;
  } catch (error) {
    console.log(error)
  }
}

export async function getProductosPDF(Documento) {
  try {
    const res = await axios.get(baseURL + `/getProductosPedidosPDF?Documento[eq]=${Documento}`);
    return res.data;
  } catch (error) {
    console.log(error)
  }
}

